import * as React from 'react';
import styled, * as s from 'styled-components';
import { rem } from 'polished';
import { __, __r } from 'react-i18n';
import { Button, ButtonLink } from '../General/Button';
import { url } from 'inspector';

interface Props {
  title: string;
  description: string;
  imagePath: string;
  redirectUrl: string;
}

export const Banner = ({
  title,
  description,
  imagePath,
  redirectUrl,
}: Props) => {
  return (
    <div>
      <BannerWrapper backgroundUrl={imagePath}>
        <BannerContent>
          <Title>{`${title}`}</Title>
          {redirectUrl ? (
            <BannerButton to={redirectUrl}>{__('Nakupovať')}</BannerButton>
          ) : null}
          {description ? <BannerText>{`${description}`}</BannerText> : null}
        </BannerContent>
      </BannerWrapper>
    </div>
  );
};

// obrazok banneru musi obsahovat aj farbu
const BannerWrapper = styled.section<{ backgroundUrl: string }>`
  background-color: #ccc;
  background-image: url(${props => props.backgroundUrl});
  background-size: cover;
  background-position: center center;
  border-radius: ${rem(8)} ${rem(8)} ${rem(56)} ${rem(8)};
  padding: ${rem(128)} ${rem(80)} ${rem(96)} ${rem(80)};
  position: relative;
  overflow: hidden;
  margin-bottom: ${rem(56)};
  height: ${rem(360)};

  ${({ theme }) => theme.media(0, 'sm')} {
    padding: ${rem(60)} ${rem(24)};
    border-radius: ${rem(0)} ${rem(0)} ${rem(56)} ${rem(0)};
    margin-bottom: ${rem(32)};
  }
`;

const BannerContent = styled.article`
  max-width: 60%;
  display: inline-block;

  ${({ theme }) => theme.media(0, 'sm')} {
    max-width: initial;
  }
`;

// line-height v dizajne je 38px co je ale malo pre dlhy text,
// v pripade ak sa zalomi
const Title = styled.h1`
  font-size: ${rem(48)};
  color: ${({ theme }) => theme.colors.secondary};
  margin-bottom: ${rem(32)};
  line-height: ${rem(48)};
  font-family: objektiv-mk1, sans-serif;
  font-weight: bold;

  ${({ theme }) => theme.media(0, 'sm')} {
    font-size: ${rem(24)};
    line-height: ${rem(31)};
    margin-bottom: ${rem(24)};
  }
`;

const BannerButton = styled(ButtonLink)`
  display: inline-block;
  color: ${({ theme }) => theme.colors.white};
  background-color: #b4ace5;
  border: none;
  padding: ${rem(14)} ${rem(32)};
  margin-bottom: ${rem(56)};
  font-weight: 500;

  ${({ theme }) => theme.media(0, 'sm')} {
    padding: ${rem(10)} ${rem(24)};
    margin-bottom: 0;
    width: initial;
    height: ${rem(40)};
  }
`;

const BannerText = styled.p`
  font-size: ${rem(13)};
  line-height: ${rem(19.5)};
  color: ${({ theme }) => theme.colors.secondary};
  position: relative;
  padding-left: ${rem(16)};
  margin: 0;
  font-weight: 400;

  ${({ theme }) => theme.media(0, 'sm')} {
    display: none;
    padding-left: 0;
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    display: inline-block;
    width: ${rem(2)};
    height: 100%;
    background: #b4ace5;

    ${({ theme }) => theme.media(0, 'sm')} {
      display: none;
    }
  }
`;
